import React from 'react';

/**
 * TextareaField - Multi-line text input field
 *
 * @param {Object} props
 * @param {Object} props.field - Field configuration
 * @param {string} props.field.key - Unique field identifier
 * @param {string} props.field.label - Display label
 * @param {string} [props.field.placeholder] - Placeholder text
 * @param {string} [props.field.default] - Default value
 * @param {number} [props.field.rows] - Number of visible rows (default: 3)
 * @param {string} props.value - Current value
 * @param {Function} props.onChange - Callback when value changes
 * @param {boolean} [props.disabled] - Whether field is disabled
 * @param {string} [props.error] - Error message to display
 */
export default function TextareaField({ field, value, onChange, disabled = false, error }) {
  const handleChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-2">
        {field.label}
      </label>
      <textarea
        value={value ?? ''}
        onChange={handleChange}
        disabled={disabled}
        rows={field.rows || 3}
        placeholder={field.placeholder || field.default || ''}
        className={`w-full px-2 py-1 text-xs border rounded resize-y ${
          error
            ? 'border-red-500 focus:ring-red-500'
            : 'border-gray-300 focus:ring-indigo-500'
        } ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
      />
      {error && (
        <p className="mt-1 text-xs text-red-500">{error}</p>
      )}
    </div>
  );
}
